<template>
      <v-row class="ma-0">
        <!-- Selection of list, only for loggedIn users for prof view only-->
        <v-col class="px-2-0">
          <v-select
            v-model="selectedShoppingList"
            :items="listItems"
            item-text="ShoppingListName"
            :label="$translate('PICK_A_LIST')"
            outlined
            return-object
            hide-details="auto"
            @change="onListSelectionChange"
            dense
          />
        </v-col>
      </v-row>
</template>

<script>
import { SHOPPING_CONTAINER } from '@/shared/constants';
export default {
  name: 'ProfessionalViewSelectList',
  mounted() {
    this.initListSelection();
  },
  computed: {
    userLoggedIn() {
      return this.$store.getters['auth/isValid'];
    },
    currentSelectedShoppingList() {
      return this.$store.getters.getCurrentSelectedShoppingList;
    },
    listItems() {
      return [this.shoppingCart, ...this.shoppingLists];
    },
    shoppingLists() {
      const lists = this.$store.getters['shoppingList/orders'];
      if (lists == null || lists.length === 0) {
        return [];
      }

      const listsCopy = [];
      lists.forEach((list) => {
        listsCopy.push({
          ShoppingListId: list.ShoppingListId,
          ShoppingListName: list.ShoppingListName,
        });
      });

      return listsCopy;
    },
  },
  data() {
    return {
      nameInput: '',
      shoppingCartId: SHOPPING_CONTAINER.ShoppingCart,
      newShoppingListId: SHOPPING_CONTAINER.NewShoppingList,

      shoppingCart: {
        ShoppingListId: SHOPPING_CONTAINER.ShoppingCart,
        ShoppingListName: this.$translate('SHOPPING_CART_NAME'),
      },
      selectedShoppingList: {},
    }
  },
  watch: {
    currentSelectedShoppingList() {
      this.initListSelection();
    },
  },
  methods: {
    initListSelection() {
      if (!this.userLoggedIn) {
        // Shopping cart only
        this.selectedShoppingList = { ...this.shoppingCart };
      } else if (
        this.currentSelectedShoppingList != null &&
        this.currentSelectedShoppingList.ShoppingListId != null
      ) {
        this.selectedShoppingList = { ...this.currentSelectedShoppingList };
      } else {
        this.selectedShoppingList = { ...this.shoppingCart };
      }
    },
    onListSelectionChange() {
      // User changed the list selection, update selection in store
      if (
        this.selectedShoppingList.ShoppingListId !== null
      ) {
        this.$store.commit(
          'setCurrentSelectedShoppingList',
          this.selectedShoppingList
        );
      }
    },
  }
}
</script>


<style scoped lang="scss">

</style>
